import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import {
  Layout,
  HoInvitedHero,
  HoInvitedReadyToStart,
  NewsLetterBar,
} from '../../../v2/components/common';
import {
  BetterWayToBuild,
  TrustedByContractorsLogo,
} from '../../../v2/components/invited-by-insurance';

const InvitedByInsurance: React.FC = () => (
  <Layout>
    <HoInvitedHero
      backgroundColor="green.500"
      header="Why did my insurer invite me to use HOVER?"
      body="Dealing with property damage is stressful enough—filing a claim should be the easiest part."
      mt={{ base: 0, desktop: 1000 }}
    >
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="invited by insurance hero"
        src="../../../v2/assets/images/invited_by_insurance_hero.png"
      />
    </HoInvitedHero>
    <BetterWayToBuild />
    <TrustedByContractorsLogo />
    <HoInvitedReadyToStart backgroundColor="green.500" />
    <NewsLetterBar />
  </Layout>
);

export default InvitedByInsurance;
